import React from 'react';

import {
  userRoles,
  UserRoleTypes,
} from '../../../../../../../../shared/constants/userRoles';

export const getDescriptionInfo = (role: UserRoleTypes) => {
  const adminInfo = (
    <span>
      Login ID can be used as a login to the dashboard.
      <br />
      Whenever you are changing Login ID, entity need use one as a login.
    </span>
  );

  const inbodyAdminInfo = <span>Login ID can be used as a login to the dashboard.</span>;

  const entityInfo = (
    <span>
      Login ID can be used as a login to the dashboard.
      <br />
      Whenever you are changing your Login ID, you need use one as a login.
    </span>
  );

  switch (role) {
    case userRoles.SUPERUSER:
      return adminInfo;
    case userRoles.INBODY_ADMIN:
      return inbodyAdminInfo;
    default:
      return entityInfo;
  }
};
